import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CategoriesService } from '@services/categories/categories.service';
import { CategoryListsService } from '@services/category-lists/category-lists.service';
import { StepsService } from '@services/step/steps.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class InitFilterRecordsService implements Resolve<any>{

  arrayFilterCompleted$ = new BehaviorSubject<any>({});
  arrayFilterCompleted: any;
  choiceType = ['Input', 'Output'];


  constructor(
    private stepsService: StepsService,
    private categoryListService: CategoryListsService,
    private categoriesService: CategoriesService,
  ) { }

  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): any {
    this.getFilter();
    return 'test';
  }

  getFilter() {

    this.stepsService.getSteps().subscribe(resSteps => {

      const steps = JSON.parse(JSON.stringify(resSteps));
      const stepFormat = {
        title: 'Étape',
        value: steps
      };

      const type = {
        type: {
          title: 'Type',
          input: [],
          output: [],

        }
      };

      stepFormat.value.forEach(step => {
        const newStep = Object.assign(step, type);
        // this.arrayFilterCompleted.push(newStep);
      });

      stepFormat.value.forEach(step => {

        this.categoryListService.getCategoryList(step.id).subscribe(resType => {
          const typeInputForSearch = resType.find(item => item.type === 'Input' && item.description === 'Catégorie');
          const typeOutputForSearch = resType.find(item => item.type === 'Output' && item.description === 'Catégorie');

          this.categoriesService.getCategories(typeInputForSearch.id).subscribe(resCat => {
            step.type.input = {
              name: 'Catégorie',
              value: resCat
            };
          });

          this.categoriesService.getCategories(typeOutputForSearch.id).subscribe(resCat => {
            step.type.output = {
              title: 'Catégorie',
              value: resCat
            };
          });
        });
      });

      this.arrayFilterCompleted = JSON.parse(JSON.stringify(stepFormat));
      this.arrayFilterCompleted$.next(this.arrayFilterCompleted);

    });


  }


}
